import React from 'react'
import AdminBreadcrumb from '../../../components/Administration/General/Admin-breadcrumb'
import { useHistory } from 'react-router-dom'

const AquaaAdminLanding = () => {
    const history = useHistory();

    const SubAppsData = [
        {
            id: 1,
            href: "/aquaaadminonboardlanding",
            name: 'AQuAA Onboard ',
            enable: true,
            visible:1
        }
    ]
  return (
    <div>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={false}  label2='AQuAA'/>
   <div style={{display:'flex',flexWrap:'wrap'}}> {SubAppsData.map((app, index) => (
        (app.enable && app.visible === 1) ? (
            <div key={index} >
            <div className='App_cards' key={app.id} onClick={() => history.push(app.href)}>
        {app.img ? (
          <img src={app.img} alt='' height='200px' width='200px' />
        ) : (
          <div style={{ height: '200px', width: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px', fontWeight: 'bold', border: '1px solid #ccc',color:'#004aac' }}>
            {app.name}
          </div>
        )}
      </div>
            </div>
        ) : (
            app.visible === 1 && (
                <div key={index} className='aquaaApps_list_disabled'>
                    {app.name}
                </div>
            )
        )
    ))}</div>
</div>
  )
}

export default AquaaAdminLanding